export default __webpack_public_path__ + "static/conversion-80ba914943b40e0d20cb1f3c9ae8c6c6.svg";